import React from "react";
import { Button, Icon, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";

const BorderDiv = styled(Typography).attrs()`
  position: absolute;
  width: 100%;
  left: 0px;
  border: 1px solid transparent;
  opacity: 0;
  &:hover {
    border: ${(props) => `1px solid ${props.theme.palette.primary.c02}`};
    display: unset !important;
    padding: 0px !important ;
    opacity: 1;
  }
`;

const CustomEditDiv = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.background.c00};
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
  box-shadow: 0px 8px 20px 1px rgba(54, 42, 102, 0.1);
  z-index: 99;
`;

const EditMask = ({
  height = null,
  toggleModalState,
  deleteBanner,
  top = null,
  buttonText,
  imgSrc = ""
}) => {
  return (
    <BorderDiv className={`${!height ? "h-100" : ""}`} style={{ height, top }}>
      <div
        className="d-flex align-items-center justify-content-end"
        style={{
          marginTop:
            buttonText === "Button Text" || buttonText === "Message"
              ? "-16px"
              : "16px",
          marginRight:
            buttonText === "Button Text" || buttonText === "Message"
              ? "-16px"
              : "16px",
        }}
      >
        <CustomEditDiv className="d-flex flex-column justify-content-center align-items-start">
          {buttonText === "Banner" && !imgSrc ? "" : <Button
            onClick={toggleModalState}
            variant="plain"
            color="common"
            shade="white"
            startIcon={
              <Icon color="primary" iconName="Edit" shade="c02" size="16" />
            }
          >
            <Typography.ButtonText color="primary" shade="c02" className="ml-8">
              Edit {buttonText}
            </Typography.ButtonText>
          </Button>}
          {buttonText === "Banner" && imgSrc ? <Button
            onClick={deleteBanner}
            variant="plain"
            color="common"
            shade="white"
            startIcon={
              <Icon color="primary" iconName="PlumDelete" shade="c02" size="16" />
            }
          >
            <Typography.ButtonText color="primary" shade="c02" className="ml-8">
              Remove {buttonText}
            </Typography.ButtonText>
          </Button> : ""}

        </CustomEditDiv>
      </div>
    </BorderDiv>
  );
};

export default EditMask;
